// English locale. Keep keys short and namespaced by area to keep the runtime
// JSON tight. Backend error codes are mapped on the consumer side, so we only
// translate user-visible UI copy here.

export default {
    brand: {
        short:   'EIT',
        full:    'Egyptian International Tourism Developments',
        tagline: 'Owners Portal',
    },
    common: {
        signIn:        'Sign in',
        signOut:       'Sign out',
        cancel:        'Cancel',
        save:          'Save changes',
        send:          'Send',
        upload:        'Upload',
        back:          'Back',
        loading:       'Loading…',
        retry:         'Try again',
        download:      'Download',
        copy:          'Copy',
        copied:        'Copied',
        yes:           'Yes',
        no:            'No',
        and:           'and',
        language:      'Language',
    },
    nav: {
        dashboard:  'Dashboard',
        statement:  'Statement',
        upload:     'Upload',
        profile:    'Profile',
        units:      'Units',
    },
    auth: {
        emailLabel:        'Email address',
        passwordLabel:     'Password',
        rememberMe:        'Remember me',
        forgotPassword:    'Forgot password?',
        signInCta:         'Sign in',
        signingIn:         'Signing in…',
        landing: {
            title:    'Your home on the Red Sea, at a glance.',
            sub:      'A private portal for the residents and investors of Egyptian International Tourism Developments.',
            secure:   'Encrypted access. One account per client.',
        },
        activate: {
            title:    'Set your password',
            sub:      'Choose a password to activate your portal account. You will be signed in automatically.',
            newPw:    'New password',
            confirm:  'Confirm password',
            cta:      'Activate account',
        },
        forgot: {
            title:    'Reset your password',
            sub:      'Enter your email; if an account exists we will send a reset link.',
            cta:      'Send reset link',
            sent:     'If the email is on file, a reset link has been sent.',
        },
        reset: {
            title:    'Choose a new password',
            cta:      'Update password',
            updated:  'Password updated. You can sign in now.',
        },
        errors: {
            badCredentials:    'Email or password is incorrect.',
            locked:            'Account is locked. Try again in a few minutes or reset your password.',
            noActiveContract:  'You have no active contracts; access denied.',
            suspended:         'Account suspended. Contact us.',
            tokenInvalid:      'This link is invalid or has expired.',
            passwordTooShort:  'Password must be at least 8 characters.',
            unknown:           'Something went wrong. Try again.',
            passwordsMismatch: 'Passwords do not match.',
        },
    },
    units: {
        switcherLabel:     'Active unit',
        selectFirst:       'Select a unit to continue.',
        empty:             'No active units.',
    },
    dashboard: {
        balanceHeading:    'Current balance',
        asOf:              'As of {{when}}',
        multiCurrency:     'Multi-currency',
        recent:            'Recent transactions',
        viewStatement:     'View full statement',
        uploadProof:       'Upload payment proof',
        noActivity:        'No activity yet.',
        sharedAccount:     'This statement covers {{n}} units under one account.',
    },
    statement: {
        title:         'Statement',
        rangeLabel:    'Range',
        last30:        'Last 30 days',
        last90:        'Last 90 days',
        ytd:           'Year to date',
        all:           'All time',
        col_num:       '#',
        col_date:      'Date',
        col_desc:      'Description',
        col_dbt:       'Debit',
        col_cdt:       'Credit',
        col_balance:   'Balance',
        opening:       'Opening balance',
        closing:       'Closing balance',
        downloadPdf:   'Download PDF',
        empty:         'No transactions in this period.',
    },
    upload: {
        title:        'Upload payment proof',
        sub:          'Bank-transfer receipts, deposit slips, or any payment evidence. Visible to EIT staff only.',
        fileLabel:    'File',
        notesLabel:   'Notes (optional)',
        pickFile:     'Choose file',
        dropHere:     'Drop your file here, or click to browse.',
        limits:       'PDF, JPEG, PNG, or WebP. Up to 10 MB.',
        cta:          'Submit',
        success:      'Upload received. Staff will be notified.',
        tooLarge:     'File is larger than 10 MB.',
        unsupported:  'That file type is not accepted.',
    },
    profile: {
        title:           'Profile',
        readonly:        'Read-only',
        editable:        'Editable',
        photos:          'Identity images',
        fullName:        'Full name',
        email:           'Email',
        idNo:            'National ID No.',
        psNo:            'Passport No.',
        tel:             'Phone',
        adrs:            'Address',
        nationality:     'Nationality',
        dob:             'Date of birth',
        photo:           'Profile photo',
        nationalId:      'National ID image',
        passport:        'Passport image',
        replace:         'Replace',
        uploadImage:     'Upload image',
        imageLimits:     'JPEG, PNG, or WebP. Up to 10 MB.',
        changePassword:  'Change password',
        currentPassword: 'Current password',
        newPassword:     'New password',
        confirmPassword: 'Confirm new password',
        saved:           'Saved.',
    },
    a11y: {
        skipToContent: 'Skip to content',
        menu:          'Menu',
    },
};
